import { ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, DoCheck, forwardRef, Input, OnInit } from '@angular/core';
import { PeriodDetails } from './models/PeriodDetails';

@Component({
  selector: 'app-repeat-select-component',
  templateUrl: './repeatSelectComponent.html',
  styleUrls: ['./repeatSelectComponent.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RepeatSelectComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useValue: (c: FormControl) => {
        const err = {
          invalid: {
            content: 'Form invalid',
          },
        };

        if (!c.value.controls || !c.value.controls.period) {
          return null;
        }

        if (c.value.controls.period.value === 'single') {
          return null;
        }

        if (c.value.controls.period.value === 'weekly') {
          return c.value.controls.daysOfWeek.status === 'INVALID' ? err : null;
        }

        if (c.value.controls.period.value === 'monthly') {
          return c.value.controls.dayOfMonth.status === 'INVALID' ? err : null;
        }

        return null;
      },
      multi: true,
    },
  ],
})
export class RepeatSelectComponent implements OnInit, DoCheck, ControlValueAccessor {
  @Input() formControl: FormControl;
  public repeatSelect: FormGroup;

  private propagateChange = (_: any) => { };

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  private propagateTouch = (_: any) => { };

  registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }

  writeValue(value: PeriodDetails) {
    this.repeatSelect.patchValue(value);
  }

  ngDoCheck() {
    if (this.formControl.touched) {
      this.repeatSelect.get('daysOfWeek').markAsTouched();
      this.repeatSelect.get('dayOfMonth').markAsTouched();
    }
  }

  ngOnInit() {
    this.repeatSelect = new FormGroup({
      period: new FormControl(),
      daysOfWeek: new FormControl(),
      dayOfMonth: new FormControl(),
    });

    this.repeatSelect.valueChanges.subscribe((change) => {
      this.propagateChange(this.repeatSelect);
    });

    this.repeatSelect.get('period').valueChanges.subscribe((change) => {
      this.repeatSelect.get('daysOfWeek').markAsUntouched();
      this.repeatSelect.get('dayOfMonth').markAsUntouched();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/clients/views/addEditTaskView/RepeatSelectComponent/repeatSelectComponent.ts